module.exports = __webpack_public_path__ + "static/media/2.afc86d3f.jpg";